import { render, staticRenderFns } from "./SelectCompWrapper.vue?vue&type=template&id=03a0bac6&scoped=true&"
import script from "./SelectCompWrapper.vue?vue&type=script&lang=js&"
export * from "./SelectCompWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SelectCompWrapper.vue?vue&type=style&index=0&id=03a0bac6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a0bac6",
  null
  
)

export default component.exports